export const handleNavLinks = (event, url, navigate, setNavActive) => {
  if (event?.target?.name === "AppList") {
    setNavActive(event.target.name);
    navigate("/home");
  }

  const navLinks = document.querySelectorAll(".nav-link");
  for (let navLink of navLinks) {
    navLink.classList.remove("active");
    navLink.setAttribute("aria-current", null);

    if (event?.force && event.force === navLink.name) {
      navLink.classList.add("active");
      navLink.setAttribute("aria-current", "page");
    }
  }

  if (event?.target?.classList) {
    event.target.classList.add("active");
    event.target.setAttribute("aria-current", "page");
  }

  if (event?.target?.name) {
    setNavActive(event.target.name);
  }

  if (url) {
    navigate(url);
  } else {
    //navigate("/");
  }
};
